<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
          <strong>Invitados al evento</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline>
            <input
              v-on:keydown.enter.prevent="''"
              class="mr-sm-2 filter-input"
              type="text"
              v-model="search"
              style="width: 100% !important; border: 0px !important;"
              placeholder="Buscar invitado"
            />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#f5f6fa', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <div
            class="text-left"
            style=" margin-left: -20px; float: left; display: flex; padding-left: 1rem;"
          >
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Volver al listado</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="returnToTable"
              >
                <mdb-icon icon="angle-left" class="mt-0" style="color: black" />
              </mdb-btn>
            </mdb-tooltip>
            <span class="event-title">Evento: {{titleEvent}}</span>
          </div>
          <span class="Nombre-de-los-invitados">Nombre de los invitados</span>
          <div class="text-right buttons-header">
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Agregar invitado</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="addInvited"
                :style="{background: '#a9bfa2 !important' }"
              >
                <mdb-icon icon="plus" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Editar invitado</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="editInvited"
                :style="{background: '#025897 !important' }"
              >
                <mdb-icon icon="pencil-alt" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Descartar invitado</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="deleteInvited"
                :style="{background: '#025897 !important' }"
              >
                <mdb-icon icon="trash-alt" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>
        <mdb-card-body>
          <div class="text-left">
            <mdb-input
              class="form-check-input"
              type="checkbox"
              id="selectAllGuest"
              v-model="selectAll"
              :style="{display: 'inline-block', marginTop: '3%', marginLeft: '1%' }"
              @click="selectA"
            />Seleccionar todo
          </div>
          <div class="listGuestClass" style="margin-top: 1rem;">
            <ul id="listWorkers" :style="{columnCount: perColumns}">
              <li
                v-for="(item, index) in displayedPost"
                v-bind:key="index"
                style="margin: 1rem; list-style:none;"
              >
                <mdb-card class="RowBG" testimonial>
                  <mdb-card-body>
                    <div
                      class="form-check checkbox-warning-filled"
                      style="margin-left: -2rem; top: 1rem; position: absolute;"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input filled-in"
                        v-model="selected"
                        :value="item.id"
                        :id="'card'+item.id"
                        :data-uuid="item.uuid"
                      />
                      <label class="form-check-label" :for="'card'+item.id"></label>
                    </div>
                    <div class="text-center">
                      <span class="font-weight-bold">{{item.firstName+' '+item.lastName}}</span>
                    </div>
                  </mdb-card-body>
                </mdb-card>
              </li>
            </ul>
          </div>

          <nav aria-label="Page navigation example">
            <ul class="pagination pg-blue justify-content-center">
              <li class="page-item">
                <a
                  v-if="page != 1"
                  class="page-link Trazado-295"
                  @click="page--"
                  tabindex="-1"
                >&laquo;</a>
              </li>
              <li
                class="page-item"
                v-for="pageNumber in pages.slice(page-1, page+5)"
                :key="pageNumber"
              >
                <a class="page-link Trazado-295" @click="page = pageNumber">{{pageNumber}}</a>
              </li>
              <li class="page-item">
                <a v-if="page < pages.length" @click="page++" class="page-link Trazado-295">&raquo;</a>
              </li>
            </ul>
          </nav>
          <div class="mb-0 text-right">
            <button
              type="submit"
              @click="downloadInvitations"
              class="btn btn-verde"
              style="padding: 5px 5px; font-size: 12px; width: 140px; height: 37px; margin-top: 1rem; margin-right: 2rem;"
              :disabled="false"
            >Descargar invitación</button>
          </div>

          <!--Bottom Table UI-->
        </mdb-card-body>
        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
    <!--Modal edit invited -->

    <mdb-modal :show="elegant" @close="elegant = false" info>
      <mdb-modal-header class="text-center modal-header-guest">
        <mdb-modal-title tag="h3" bold class="w-100 my-3">{{ModalTitle}}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <form id="form1" class="needs-validation" @submit="saveEdit">
          <mdb-row>
            <mdb-col md="5">
              <div class="form-group">
                <label
                  for="invitedFirstName"
                  style="font-size: 13px; font-family: OpenSans-Bold;"
                >Nombre</label>
                <input
                  class="Rectangle-536"
                  type="text"
                  id="invitedFirstName"
                  required
                  v-model="invitedEdit.firstName"
                />
              </div>
            </mdb-col>
            <mdb-col md="5">
              <div class="form-group">
                <label
                  for="invitedLastName"
                  style="font-size: 13px; font-family: OpenSans-Bold; margin-left: 2rem;"
                >Apellidos</label>
                <input
                  class="Rectangle-536"
                  type="text"
                  id="invitedLastName"
                  style="margin-left: 2rem;"
                  required
                  v-model="invitedEdit.lastName"
                />
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col md="5">
              <div class="form-group">
                <label
                  for="invitedPhone"
                  style="font-size: 13px; font-family: OpenSans-Bold;"
                >Teléfono</label>
                <input
                  class="Rectangle-536"
                  type="number"
                  id="invitedPhone"
                  v-model="invitedEdit.phone"
                />
              </div>
            </mdb-col>
            <mdb-col md="5">
              <div class="form-group">
                <label
                  for="invitedEmail"
                  style="font-size: 13px; font-family: OpenSans-Bold; margin-left: 2rem;"
                >Correo electrónico</label>
                <input
                  class="Rectangle-536"
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  style="margin-left: 2rem;"
                  id="invitedEmail"
                  v-model="invitedEdit.email"
                />
              </div>
            </mdb-col>
          </mdb-row>
          <div class="text-center mb-3">
            <mdb-btn color="color-prev" class="btn-prev" @click="closeModal">Cancelar</mdb-btn>
            <button type="submit" class="btn btn-next btn-color-next">Guardar</button>
            <mdb-btn
              type="button"
              class="btn-verde"
              @click="modalImport = true"
            >Importar desde plantilla</mdb-btn>
          </div>
        </form>
      </mdb-modal-body>
    </mdb-modal>

    <!--IMPORTAR DESDE PLANTILLA -->
    <mdb-modal :show="modalImport" @close="modalImport = false" info>
      <mdb-modal-header class="text-center modal-header-guest">
        <mdb-modal-title tag="h3" bold class="w-100 my-3">Importación masiva</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col md="6">
            <div class="md-form mb-0">
              <span>1.- Descarga la plantilla de invitados</span>
            </div>
          </mdb-col>
          <mdb-col md="6">
            <div class="md-form mb-0">
              <span>2.- Adjunta la plantilla de invitados</span>
            </div>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="6">
            <div class="md-form mb-0">
              <a
                :href="imgServer+'apps/myfrac/admin/assets/lista_invitados.xlsx'"
                class="btn btn-verde"
                role="button"
                style="font-family: OpenSans-Semibold; font-size: 12px; width: 137px; height: 45px; text-transform: capitalize; object-fit: contain;"
                download
              >Descargar</a>
            </div>
          </mdb-col>
          <mdb-col md="6">
            <div v-show="(!uploadingCSV && !uploadSuccess)">
              <div class="row center-align" style="margin-bottom: 10px;">
                <div class="col s12 m12 l12"></div>
              </div>
              <div class="row">
                <div class="form-csv">
                  <form enctype="multipart/form-data" id="fileUploadForm">
                    <input
                      id="file_csv"
                      name="file"
                      type="file"
                      accept=".xlsx"
                      ref="fileupload"
                      @change="signalChange"
                    />
                    <div
                      id="csv-success"
                      class="center-align ml-3 mr-3"
                      style="font-size: 12px; text-align: center; margin-top: 15%; color: #a09c9c;"
                    >
                      <i
                        class="far fa-copy"
                        style="padding: 15px 10px; font-size: 30px; color: #e8e9ec;"
                      ></i>
                      <br />Arrastra la plantilla aquí o
                      <u style="color:blue;">
                        <span style="color:blue;">adjúntala desde tu computadora</span>
                      </u>
                    </div>
                    <h6 id="csv-failed" class="center-align" style="display: none">
                      <u style="color:red;">
                        <span style="color:red;">Intenta de nuevo</span>
                      </u>
                    </h6>
                  </form>
                </div>
              </div>
            </div>
            <div v-show="(uploadingCSV && !uploadSuccess)">
              <div class="row" style="margin-bottom: 25%;"></div>
              <div class="row center-align">
                <h4 style="color:#5d6078">Importando Lista</h4>
                <h5 style="color:#5d6078">Espera un momento</h5>
                <div class="progress">
                  <div class="indeterminate"></div>
                </div>
              </div>
            </div>
            <div v-show="(!uploadingCSV && uploadSuccess)">
              <div class="row center-align" v-show="badlist">
                <div class="col s12 m12 l12">
                  <p style="font-size: 20px; margin:0;">
                    Algunos invitados no se pudieron insertar.
                    <a
                      style="cursor: pointer;"
                      onclick="downloadbadExcel()"
                    >Descargar</a>
                  </p>
                  <ul style="margin:0;">Causas</ul>
                </div>
              </div>
              <div class="row center-align csvuploadsuccess">
                <h4 style="color:#5d6078; padding-top: 15%;">Lista importada exitosamente</h4>
                <h5 style="color:#5d6078;">Los invitados fueron agregados con éxito</h5>
              </div>
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>
</template>
<script lang="javascript" src="../../dist/xlsx.full.min.js"></script>
<script>
/* eslint-disable */
import XLSX from "xlsx";
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardText,
  mdbCardGroup,
  mdbBtn,
  mdbTooltip,
  mdbIcon,
  mdbInput,
  mdbCardHeader,
  mdbListGroup,
  mdbListGroupItem,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbDatatable,
  mdbFormInline
} from "mdbvue";

export default {
  name: "GuestsList",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardText,
    mdbCardGroup,
    mdbBtn,
    mdbTooltip,
    mdbIcon,
    mdbInput,
    mdbCardHeader,
    mdbListGroup,
    mdbListGroupItem,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbDatatable,
    mdbFormInline
  },
  data() {
    return {
      selected: [],
      guestSelected: [],
      guestDuplicate: [],
      guestNew: [],
      elegant: false,
      modalImport: false,
      check1: false,
      selectAll: false,
      indexEdit: null,
      isEdit: null,
      uploadingCSV: false,
      uploadSuccess: false,
      badlist: false,
      donwloadBtn: false,
      residentsFile: "",
      titleEvent: "",
      ModalTitle: "",
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      data: {
        columns: [
          {
            label: "",
            field: "checkbox"
          },
          {
            label: "Nombre del invitado",
            field: "name",
            sort: "asc"
          }
        ],
        rows: []
      },
      invitedEdit: {
        uuid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      },
      guestList: [],
      page: 1,
      perPage: 15,
      perColumns: 3,
      pages: [],
      numberOfPages: 0,
      search: null
    };
  },
  methods: {
    selectA() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.guestList) {
          this.selected.push(this.guestList[i].id);
        }
      }
    },
    getOneEvent(uuid) {
      let aux = this;
      return Axios.get(this.urlServer + "api/massiveEvents/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {})
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    closeModal() {
      //this.show = false;
      this.elegant = false;
      this.isEdit = null;
      this.modalImport = false;
      //this.massiveEvents = null;
      this.invitedEdit = {
        uuid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      };
      this.indexEdit = null;
      this.guestNew = [];
      this.guestDuplicate = [];
    },
    deleteInvited() {
      this.makeListOfGuest();
      if (this.guestSelected.length == 0) {
        this.showMessageInfo(
          "Para realizar esta acción, asegúrate de seleccionar un invitado."
        );
      } else if (this.guestSelected.length == 1) {
        let aux = this;

        for (var key = 0; key <= aux.guestSelected.length; key++) {
          //var index = aux.guestSelected[key].indexGuest;
          aux.invitedEdit = aux.guestList[key];
          Swal.fire({
            title:
              "<span style='font-size: 20px;'>¿Seguro que deseas eliminar a " +
              aux.invitedEdit.firstName +
              " " +
              aux.invitedEdit.lastName +
              "?</span>",
            html:
              "<span style='font-size: 12px;'>No podrás revertir esta acción</span>",
            type: "question",
            showCancelButton: true,
            width: "30%",
            //confirmButtonColor: "#3085d6",
            //cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
            customClass: {
              confirmButton: "btn-modal-accept",
              cancelButton: "btn-modal-cancel"
            }
          }).then(result => {
            if (result.value) {
              //this.$delete(this.rows, index);
              var uuidDelete = aux.invitedEdit.uuid;
              if (uuidDelete != "") {
                aux.deleteGuest(uuidDelete);
              }
              aux.$delete(aux.guestList, key);
            }
          });
        }
      } else {
        this.showMessageError(
          "No es posible eliminar más de un invitado a la vez",
          ""
        );
      }
    },
    editInvited() {
      this.makeListOfGuest();
      if (this.guestSelected.length == 0) {
        this.showMessageInfo(
          "Para realizar esta acción, asegúrate de seleccionar un invitado."
        );
      }
      if (this.guestSelected.length == 1) {
        this.isEdit = true;
        this.elegant = true;
        this.ModalTitle = "Editar invitado";
        //this.indexEdit = this.guestSelected[0].indexGuest;
        this.invitedEdit = this.guestSelected[0];
      }
      if (this.guestSelected.length > 1) {
        this.showMessageError(
          "No es posible editar más de un invitado a la vez",
          ""
        );
      }
    },
    addInvited() {
      this.ModalTitle = "Agregar invitado";
      this.elegant = true;
      this.isEdit = false;
      this.invitedEdit = {
        uuid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      };
    },
    saveEdit(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      this.elegant = false;
      if (this.isEdit === false) {
        this.saveGuest();
      } else if (this.isEdit === true) {
        this.$set(
          this.guestList[this.indexEdit],
          "firstName",
          this.invitedEdit.firstName
        );
        this.$set(
          this.guestList[this.indexEdit],
          "lastName",
          this.invitedEdit.lastName
        );
        this.$set(
          this.guestList[this.indexEdit],
          "phone",
          this.invitedEdit.phone
        );
        this.$set(
          this.guestList[this.indexEdit],
          "email",
          this.invitedEdit.email
        );
        this.updateGuest(this.invitedEdit);
      }
      this.closeModal();
    },
    saveGuest() {
      let found = this.guestList.find(
        element =>
          element.firstName === this.invitedEdit.firstName &&
          element.lastName === this.invitedEdit.lastName
      );
      if (found == undefined) {
        Swal.fire({
          title: "<span style='font-size: 20px;'>Cargando invitado...</span>",
          width: "20%",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
            this.addGuest(this.invitedEdit);
            this.guestList.push(this.invitedEdit);
          }
        });

        //this.closeModal();
      } else {
        Swal.fire({
          title:
            "<span style='font-size: 20px;'>¿Estas seguro de agregar a este invitado nuevamente?</span>",
          html:
            "<span style='font-size: 12px;'> Encontramos un invitado con este nombre y apellido: " +
            this.invitedEdit.firstName +
            " " +
            this.invitedEdit.lastName +
            "</span>",
          type: "warning",
          showCancelButton: true,
          reverseButtons: true,
          width: "30%",
          //confirmButtonColor: "#3085d6",
          //cancelButtonColor: "#d33",
          confirmButtonText: "Si, agregar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn-modal-accept",
            cancelButton: "btn-modal-cancel"
          }
        }).then(result => {
          if (result.value) {
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>Cargando invitado...</span>",
              width: "20%",
              allowOutsideClick: false,
              onBeforeOpen: () => {
                Swal.showLoading();
                this.addGuest(this.invitedEdit);
                this.guestList.push(this.invitedEdit);
              }
            });
            //this.closeModal();
          }
        });
      }
    },
    downloadInvitations2() {
      var type = "application/zip";
      var downloadName = "invitaciones.zip";
      var ContentType = "multipart/form-data";
      var uuidArray = "";
      if (this.guestNew.length === 1) {
        type = "image/png";
        downloadName =
          this.guestNew[0].firstName + " " + this.guestNew[0].lastName;
        +".png";
        ContentType = "image/png";
      }
      this.guestNew.map(function(value, key) {
        uuidArray = uuidArray + "uuid=" + value.uuid + "&";
      });

      uuidArray = uuidArray.slice(0, -1);

      let aux = this;
      Axios.get(
        this.urlServer + "api/massiveEventGuests/invitation?" + uuidArray,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": ContentType
          }
        }
      ).then(
        function(response) {
          let blob = new Blob([response.data], { type: type });
          const downloadUrl = URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = downloadUrl;
          a.download = downloadName;
          document.body.appendChild(a);
          a.click();
          Swal.hideLoading("Invitaciones descargadas");
          aux.closeModal();
          window.location.reload();
        },
        function(error) {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
          return false;
        }
      );
    },
    downloadInvitations() {
      this.makeListOfGuest();
      if (this.guestSelected.length > 0) {
        var type = "application/zip";
        var downloadName = "invitaciones.zip";
        var ContentType = "multipart/form-data";
        var uuidArray = "";
        if (this.guestSelected.length === 1) {
          type = "image/png";
          downloadName =
            this.guestSelected[0].firstName +
            " " +
            this.guestSelected[0].lastName +
            ".png";
          ContentType = "image/png";
        }
        this.guestSelected.map(function(value, key) {
          uuidArray = uuidArray + "uuid=" + value.uuid + "&";
        });
        uuidArray = uuidArray.slice(0, -1);

        let aux = this;
        Swal.fire({
          title: "<span style='font-size: 20px;'>Descargando ...</span>",
          width: "30%",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });
        Axios.get(
          aux.urlServer + "api/massiveEventGuests/invitation?" + uuidArray,
          {
            responseType: "arraybuffer",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": ContentType
            }
          }
        )
          .then(response => {
            let blob = new Blob([response.data], { type: type });
            const downloadUrl = URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = downloadUrl;
            a.download = downloadName;
            document.body.appendChild(a);
            a.click();
            Swal.hideLoading("");
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>Descarga completada</span>",
              width: "20%",
              allowOutsideClick: false,
              showConfirmButton: true
            });
            aux.closeModal();
          })
          .catch(error => {
            console.log(error.response);
            aux.showMessageError("Ha ocurrido un error", error.response.data);
          });
      } else {
        this.showMessageInfo(
          "Para realizar esta acción, asegúrate de seleccionar por lo menos un invitado."
        );
      }
    },
    returnToTable() {
      window.location = "/massiveEvents";
    },
    getDataTable(uuid) {
      let aux = this;
      aux.guestList = [];
      Axios.get(this.urlServer + "api/massiveEvents/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          aux.titleEvent = response.data.title;
          aux.guestList = response.data.massiveEventGuests;
          aux.numberOfPages = Math.ceil(aux.numberOfPages.length / aux.perPage);
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    cleanModel() {
      this.invitedEdit = {
        uuid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      };
    },
    deleteGuest(guest) {
      Axios.delete(this.urlServer + "api/massiveEventGuests/" + guest, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          Swal.fire({
            title: "<span style='font-size: 20px;'> Eliminado </span>",
            html:
              "<span style='font-size: 12px;'>Invitado eliminado correctamente</span>",
            type: "success",
            width: "30%",
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn-modal-accept"
            },
            onClose: () => {
              window.location.reload();
              //document.getElementById("form1").classList.remove("was-validated");
            }
          });
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    updateGuest(value) {
      let aux = this;
      var data = {
        uuid: value.uuid,
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        phone: value.phone,
        massiveEvent: {
          uuid: this.$route.query.event
        }
      };
      Axios.put(aux.urlServer + "api/massiveEventGuests/" + value.uuid, data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          Swal.fire({
            title: "<span style='font-size: 20px;'> Actualizado </span>",
            html:
              "<span style='font-size: 12px;'>Invitado actualizado correctamente</span>",
            type: "success",
            width: "30%",
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn-modal-accept"
            },
            onClose: () => {
              window.location.reload();
              //document.getElementById("form1").classList.remove("was-validated");
            }
          });
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    makeListOfGuest() {
      let aux = this;
      aux.guestSelected = [];

      var arr = Array.prototype.slice.call(
        document.getElementsByClassName("form-check-input")
      );

      aux.selected.map(function(value, key) {
        let found = aux.guestList.find(element => element.id === value);
        aux.guestSelected.push(found);
      });
      /*let aux = this;
      aux.guestSelected = [];

      if (aux.selectAll) {
        aux.guestList.map(function(value, key) {
          aux.guestSelected.push({
            uuid: value.uuid,
            indexGuest: key
          });
        });
      } else {
        var arr = Array.prototype.slice.call(
          //document.getElementsByClassName("form-check-input")
          document.getElementsByName("checkboxGuest")
        );
        arr.map(function(value, key) {
          if (value.checked) {
            aux.guestSelected.push({
              uuid: value.dataset.uuid,
              indexGuest: value.dataset.index
            });
          }
        });
      }*/
    },
    downloadNewInvitations() {
      Swal.fire({
        title:
          "<span style='font-size: 20px;'>¿Deseas descargar las nuevas invitaciones?</span>",
        width: "50%",
        showCancelButton: true,
        confirmButtonText:
          '<i class="far fa-file-archive"></i> Si, descargar invitaciones nuevas',
        cancelButtonText: '<i class="far fa-images"></i> No descargar',
        reverseButtons: true,
        showLoaderOnConfirm: true,
        customClass: {
          confirmButton: "btn-modal-accept",
          cancelButton: "btn-modal-cancel"
        },
        allowOutsideClick: false,
        onAfterClose: () => {
          Swal.fire({
            title:
              "<span style='font-size: 20px;'>Descargando invitaciones...</span>",
            width: "30%",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            }
          });
        }
      }).then(result => {
        if (result.value) {
          this.downloadInvitations2();
        } else {
          window.location.reload();
        }
      });
    },
    addMultipleGuestExcel(guests) {
      let aux = this;
      var data = {
        massiveEvent: {
          uuid: this.$route.query.event
        },
        guests: guests
      };
      Axios.post(this.urlServer + "api/massiveEventGuests/multiple", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.guestNew = response.data;
          aux.downloadNewInvitations();
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    addGuest(guest) {
      let aux = this;
      var data = {
        massiveEvent: {
          uuid: this.$route.query.event
        },
        uuid: "",
        firstName: guest.firstName,
        lastName: guest.lastName,
        email: guest.email,
        phone: guest.phone
      };
      Axios.post(this.urlServer + "api/massiveEventGuests/", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.guestNew = [];
          aux.guestNew.push(response.data);
          Swal.fire({
            title: "<span style='font-size: 20px;'> Agregado</span>",
            html:
              "<span style='font-size: 12px;'>Invitado agregado correctamente</span>",
            type: "success",
            width: "30%",
            confirmButtonText: "Aceptar",
            showConfirmButton: true,
            customClass: {
              confirmButton: "btn-modal-accept"
            },
            onBeforeOpen: () => {
              Swal.hideLoading();
            },
            onClose: () => {
              //aux.guestNew.push(guest);
              aux.downloadNewInvitations();
              //if (!aux.modalImport) window.location.reload();
              //window.location.reload();
              //document.getElementById("form1").classList.remove("was-validated");
            }
          });
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        }
      });
    },
    showMessageInfo: function(text) {
      Swal.fire({
        title: "<span style='font-size: 14px;'>" + text + "</span>",
        type: "info",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        }
      });
    },
    signalChange: function(evt) {
      this.excel2json = [];
      this.excel2jsonFail = [];
      if (evt.target.files.length > 0) {
        this.residentsFile = evt.target.files[0];
        this.convertExcelToJSON(this.residentsFile);
      } else {
        this.value = "";
      }
      this.$emit("change", evt);
    },
    convertExcelToJSON: function(fileList) {
      let aux = this;
      var rdr = new FileReader();
      var register = "";
      try {
        rdr.onload = function(e) {
          var data = new Uint8Array(rdr.result);
          var arr = new Array();
          for (var i = 0; i != data.length; ++i)
            arr[i] = String.fromCharCode(data[i]);
          var bstr = arr.join("");

          // Call XLSX
          var workbook = XLSX.read(bstr, { type: "binary" });

          // DO SOMETHING WITH workbook HERE
          var first_sheet_name = workbook.SheetNames[0];
          // Get worksheet
          var worksheet = workbook.Sheets[first_sheet_name];

          this.excel2json = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          aux.validateExcel(this.excel2json);
        };
        rdr.readAsArrayBuffer(fileList);
      } catch (error) {
        alert(
          "Formato incorrecto, porfavor sube un archivo en formato excel xlsx"
        );
      }
    },
    validateExcel: function(val) {
      let aux = this;
      this.excel2jsonFail = [];
      var keys = [];
      var c = 0;
      for (var i in val[0]) {
        var sub_key = i;
        keys.push(sub_key);
      }
      for (var i = 0; i < keys.length; i++) {
        if (i == 0 && keys[0] != "Nombre") {
          c++;
        }
        if (i == 1 && keys[1] != "Apellidos") {
          c++;
        }
        if (i == 2 && keys[2] != "Teléfono") {
          c++;
        }
        if (i == 3 && keys[3] != "Correo Electrónico") {
          c++;
        }
      }
      if (c == 0) {
        if (val.length > 0) {
          this.guestNew = [];
          this.guestDuplicate = [];
          for (var i = 0; i < val.length; i++) {
            this.invitedEdit.firstName = val[i].Nombre;
            this.invitedEdit.lastName = val[i].Apellidos;
            this.invitedEdit.phone = val[i]["Teléfono"];
            this.invitedEdit.email = val[i]["Correo Electrónico"];
            var found = this.guestList.find(
              element =>
                element.firstName === this.invitedEdit.firstName &&
                element.lastName === this.invitedEdit.lastName
            );

            if (!this.validateRowExcel()) {
              this.showMessageError(
                "No es posible completar la carga",
                "Detectamos un error en el " +
                  (i + 1) +
                  "º registro de la lista, por favor verifícalo e intenta nuevamente"
              );
              return;
            }
            if (found === undefined) {
              this.guestNew.push(this.invitedEdit);
            } else {
              this.guestDuplicate.push(this.invitedEdit);
            }
            this.invitedEdit = {
              uuid: "",
              firstName: "",
              lastName: "",
              email: "",
              phone: ""
            };
          }

          Swal.fire({
            title:
              "<span style='font-size: 20px;'> El formato es correcto</span>",
            html:
              " <div>" +
              "se detectaron: " +
              "<p>" +
              this.guestNew.length +
              " invitados nuevos</p>" +
              "<p>" +
              this.guestDuplicate.length +
              " invitados repetidos</p>" +
              "</div>",
            type: "success",
            width: "30%",
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn-modal-accept"
            },
            showConfirmButton: true,
            onClose: () => {
              this.residentsFile = "";
              const input = this.$refs.fileupload;
              input.type = "text";
              input.type = "file";
              if (aux.guestDuplicate.length > 0) {
                Swal.fire({
                  title:
                    "<span style='font-size: 20px;'>¿Estás seguro de agregarlo(s) nuevamente?</span>",
                  html:
                    "<span style='font-size: 12px;' Hemos detectado " +
                    aux.guestDuplicate.length +
                    " invitado(s) duplicado(s) </span>",
                  type: "warning",
                  showCancelButton: true,
                  reverseButtons: true,
                  width: "30%",
                  //confirmButtonColor: "#3085d6",
                  //cancelButtonColor: "#d33",
                  confirmButtonText: "Si, agregar",
                  cancelButtonText: "Cancelar",
                  customClass: {
                    confirmButton: "btn-modal-accept",
                    cancelButton: "btn-modal-cancel"
                  },
                  allowOutsideClick: false,
                  onAfterClose: () => {
                    if (aux.guestNew.length > 0) {
                      Swal.fire({
                        title:
                          "<span style='font-size: 20px;'>Cargando invitados...</span>",
                        width: "20%",
                        allowOutsideClick: false,
                        onBeforeOpen: () => {
                          Swal.showLoading();
                          aux.addMultipleGuestExcel(aux.guestNew);
                          aux.guestList.push(aux.guestNew);
                        }
                      });
                    }
                  }
                }).then(result => {
                  if (result.value) {
                    aux.guestDuplicate.map(function(value, key) {
                      aux.guestNew.push(value);
                    });
                  }
                });
              }
              if (aux.guestDuplicate.length == 0 && aux.guestNew.length > 0) {
                Swal.fire({
                  title:
                    "<span style='font-size: 20px;'>Cargando invitados...</span>",
                  width: "20%",
                  allowOutsideClick: false,
                  onBeforeOpen: () => {
                    Swal.showLoading();
                    aux.addMultipleGuestExcel(aux.guestNew);
                    aux.guestList.push(aux.guestNew);
                  }
                });
              }
            }
          });
        } else {
          console.log("Error de archivo");
        }
      } else {
        aux.showMessageError("El formato es incorrecto", "Error");
      }
    },
    pushData() {
      this.invitedEdit = {
        uuid: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      };
    },
    validateRowExcel() {
      var re = new RegExp("^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$");
      if (this.invitedEdit.firstName != "" && this.invitedEdit.lastName != "") {
        if (this.invitedEdit.email != "") {
          if (re.test(this.invitedEdit.email)) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    },
    setPages() {
      this.pages=[]
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages()
      return wList.slice(from, to);
    }
  },
  created() {
    this.getOneEvent(this.$route.query.event);
  },
  mounted() {
    this.getDataTable(this.$route.query.event);
  },
  watch: {
    guestList() {
      this.setPages();
    }
  },
  computed: {
    displayedPost() {
      if (this.search) {
      this.page=1
        return this.paginate(
          this.guestList.filter(item => {
            var nameComplete = item.firstName + " " + item.lastName;
            return (
              item.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
              item.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
              nameComplete.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
          })
        );
      } else return this.paginate(this.guestList);
    }
  }
};
</script>

<style scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}
.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.listGuestClass > ul {
  columns: 5;
  padding: 16px 0;
  list-style: none;
}

.listGuestClass > ul > li {
  display: inline-block;
  width: 100%;
  border-top: 1px;
}

.RowBG {
  width: 20rem;
  height: 50px;
  background-color: #ffffff;
}

.pagination > .active > a,
.pagination > .active > span {
  z-index: 3;
  color: #999;
  cursor: default;
  background-color: #67a3cf !important;
  border-color: #707070 !important;
}
.paginate_button {
  background: #f6f6f6 !important;
}
</style>

<style>
.filled-in:checked + label::after {
  border-color: #67a3cf !important;
  background-color: #67a3cf !important;
}
.Nombre-de-los-invitados {
  margin-left: 20%;
  font-family: OpenSans-Bold;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: #020202;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}

/* --------------------------------------------------------
 /* ---- DATATABLE
 -------------------------------------------------------- */

.modal-header-guest {
  height: auto !important;
  width: inherit !important;
  margin-left: 0rem !important;
}

.treecolumn div.dataTables_filter {
  float: left;
  margin-bottom: 0px;
}
.dataTableBuilder_filter label {
  display: none;
}

div.dataTables_wrapper div.dataTables_length {
  display: none !important;
}

.treecolumn .dataTables_filter input[search]:focus {
  font-size: 12px;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
  position: absolute;
  top: 60px;
  font-family: "OpenSans-Light" !important;
  display: none !important;
}

table.dataTable tbody tr {
  background-color: #ffffff !important;
}

.md-form input[type="search"]:focus:not([readonly]) {
  -webkit-box-shadow: 0 0px 0 0 transparent !important;
  box-shadow: unset;
  border-bottom: unset;
  outline: none !important;
}

div.dataTables_wrapper div.dataTables_filter input::placeholder {
  color: #ffffff !important;
  opacity: 1;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input:-ms-input-placeholder {
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input::-ms-input-placeholder {
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  cursor: default;
  color: #666 !important;
  border-radius: 10px !important;
  background: transparent;
  box-shadow: none;
  font-family: "OpenSans-Light" !important;
  font-size: 12px;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  box-sizing: border-box;
  display: inline-block;
  min-width: 1.5em;
  margin-left: 2px;
  text-align: center;
  text-decoration: none !important;
  cursor: pointer;
  color: #333 !important;
  border: 1px solid transparent;
  border-radius: 5px;
  padding: 0px !important;
  margin-left: 14px !important;
}

.pagination > .active > a,
.pagination > .active > span {
  z-index: 3;
  color: #999;
  cursor: default;
  background-color: #67a3cf !important;
  border-color: #707070 !important;
}

.paginate_button {
  background: #f6f6f6 !important;
}

.treecolumn .dataTables_paginate {
  width: 290px !important;
  float: right !important;
}

.treecolumn div.dataTables_paginate {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center !important;
}

.treecolumn div.dataTables_filter input {
  margin-bottom: 2rem;
  display: inline-block;
  position: absolute !important;
  bottom: 0rem;
  left: 14rem;
  width: 200px !important;
  border-radius: 25px !important;
  height: 15px !important;
  padding-left: 35px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  padding-right: 10px !important;
  font-family: "OpenSans-Regular" !important;
  font-size: 12px !important;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf !important;
  background-size: 20px 20px !important;
}

.treecolumn .table > thead:first-child > tr:first-child > th {
  display: none !important;
}

.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 2px solid #f6f6f6;
  font-family: "OpenSans-Regular" !important;
  font-size: 12px;
  color: #000000 !important;
}

.treecolumn {
  -webkit-column-count: 2; /* Chrome, Safari, Opera */
  -moz-column-count: 2; /* Firefox */
  column-count: 2;
  padding-top: 8%;
  padding-bottom: 0%;
}

.treecolumn .row {
  margin-top: -15px !important;
}

.event-title {
  width: 159px;
  height: 19px;
  font-family: OpenSans-Bold;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.btn-next {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-prev {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-color-next {
  background-color: #23a7ed !important;
  color: #fff !important;
}

.btn-color-prev {
  background-color: #ed5f5f !important;
  color: #fff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #d33 !important;
  font-size: 12px !important;
}

.btn-modal-download {
  height: 50% !important;
  width: auto !important;
  background-color: #a4a8ab !important;
  font-size: 12px !important;
}

.Rectangle-536 {
  width: 190px;
  height: 37px;
  border-radius: 4px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.buttons-header {
  margin-top: -10px;
  margin-right: -20px;
  float: right;
}

.table {
  border-collapse: unset !important;
  margin-bottom: 0.5rem !important;
  padding-bottom: 0rem !important;
  margin-top: 0.5rem !important;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100px;
  outline: none;
  opacity: 0;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

/** RESPONSIVE */

@media screen and (max-width: 1024px) {
  .treecolumn div.dataTables_filter input {
    left: 9rem !important;
  }

  .Nombre-de-los-invitados {
    margin-left: 15%;
  }
}

@media screen and (max-width: 768px) {
  .treecolumn div.dataTables_filter input {
    left: 7.5rem !important;
    bottom: -1rem !important;
    width: 150px !important;
  }

  .Nombre-de-los-invitados {
    margin-left: 9% !important;
  }

  .treecolumn .dataTables_paginate {
    width: 200px !important;
  }

  .buttons-header {
    margin-top: 10px;
  }
}

@media screen and (min-width: 1440px) {
  .treecolumn div.dataTables_filter input {
    left: 19.5rem !important;
  }
}

@media screen and (min-width: 2500px) {
  .treecolumn div.dataTables_filter input {
    left: 42.7rem !important;
  }
}

@media screen and (max-width: 425px) {
  .treecolumn {
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
    padding-top: 20%;
  }

  .treecolumn div.dataTables_filter input {
    left: 0rem !important;
    bottom: -1rem !important;
    width: 100px !important;
  }

  .treecolumn .dataTables_paginate {
    width: 160px !important;
  }
}

@media screen and (max-width: 375px) {
  .treecolumn {
    -webkit-column-count: 1;
    -moz-column-count: 1;
    column-count: 1;
    padding-top: 20%;
  }

  .treecolumn div.dataTables_filter input {
    left: -10rem !important;
    bottom: -1rem !important;
    width: 100px !important;
  }

  .Nombre-de-los-invitados {
    margin-left: -15% !important;
  }
}

@media screen and (max-width: 320px) {
  .Nombre-de-los-invitados {
    margin-left: 10% !important;
  }
}
</style>
